import { useContext, useEffect, useState } from "react";
import requestStatuses from "./requestStatuses.json"
import documentTypes from "./documentTypes.json"
import objectTypes from "./objectTypes.json"
import regTypes from "./regTypes.json"
import rightTypes from "./rightTypes.json"
import { HttpContext } from "../../HttpContext";

export function useRequestService(requestId) {
    const { httpClient } = useContext(HttpContext)
    const [request, setRequest] = useState()
    const [status, setStatus] = useState(requestStatuses[0])

    useEffect(() => {

        if (!isNaN(parseInt(requestId))) {
            getRequest(requestId).then(data => { setRequest(data); setStatus(requestStatuses.find(x => x.code == data.Status.code)) })
        }

    }, [requestId])


    const getRequest = async (requestId) => {
        return httpClient.get(`/request/${requestId}`).then(promise => promise.data)
    }
    const getRequests = async () => {
        return httpClient.get("/request/all").then(promise => promise.data)
    }

    const deleteDocument = async (id) => {
        return httpClient.delete(`/request/document/${id}`).then(promise => promise.data)
    }
    const deleteParticipant = async (id) => {
        return httpClient.delete(`/request/participant/${id}`).then(promise => promise.data)
    }
    const addFlSubject = async (flSubjectId, requestId) => {
        const data = {
            FlSubjectId: flSubjectId,
            RequestId: requestId,
        }
        return httpClient.post("/request/participant/flsubject", data).then(promise => promise)
    }
    const addFlSubjectWithAgent = async (flSubjectId, requestId, docTypeCode, issueDate, file, signature, flAgentId) => {
        const data = new FormData()
        data.append("FlSubjectId", flSubjectId)
        data.append("FlAgentId", flAgentId)
        data.append("DocTypeCode", docTypeCode)
        data.append("IssueDate", issueDate)
        data.append("File", file)
        data.append("Signature", signature)
        data.append("RequestId", requestId)
        data.append("TypeId", "0")

        return httpClient.post("/request/participant/flsubjectwithflagent", data).then(promise => promise)
    }
    const addUlAgent = async (ulAgentId, requestId, docTypeCode, issueDate, file, signature) => {
        const data = new FormData()
        data.append("UlAgentId", ulAgentId)
        data.append("DocTypeCode", docTypeCode)
        data.append("IssueDate", issueDate)
        data.append("File", file)
        data.append("Signature", signature)
        data.append("RequestId", requestId)
        data.append("TypeId", "0")

        return httpClient.post("/request/participant/ulagent", data).then(promise => promise)
    }
    const saveDocument = async (requestId, documentType, file, participantIds) => {
        const data = new FormData()
        data.append("RequestId", requestId)
        data.append("DocTypeCode", documentType)
        data.append("File", file)
        console.log(participantIds)
        participantIds.map((id) =>
            data.append("ParticipantIds", id)
        );
        return httpClient.post('/request/document', data).then(promise => promise.data)
    }
    const generateStatement = async (requestId) => {
        return httpClient.post(`/request/statement/generate/${requestId}`).then(promise => promise.data)
    }
    const createRequest = async (regActionId, rightTypeId) => {
        const data = {
            RegActionId: regActionId,
            RightTypeId: rightTypeId
        }
        return httpClient.post(`/request`, data).then(promise => promise)
    }
    const updateRequest = async (request) => {
        const body = {
        }
        return httpClient.put(`/request`, body).then(promise => promise.data)
    }
    const addSignature = async (documentId, participantId, file, base64, signType) => {
        const data = new FormData()
        data.append("DocumentId", documentId)
        data.append("ParticipantId", participantId)
        data.append("SignType", signType)
        if (file != null) {
            data.append("File", file)
        }
        if (base64 != null) {
            data.append("Base64", base64)
        }
        return httpClient.post("/request/document/signature", data).then()
    }
    const addUlRepresentingFl = async (requestId, ulAgentId, flSubjectId) => {
        const body = {
            "RequestId": requestId,
            "UlAgentId": ulAgentId,
            "FlSubjectId": flSubjectId,
            "ParticipantType": 0,
            "Privileged": true,
            "AgentDocTypeCode": "string",
            "DocAgentDate": "2024-02-09T11:32:29.033Z"
        }
        return httpClient.post("/request/participant/ul-representing-fl", body).then(promise => promise.data)
    }
    const sendStatement = async (requestId) => {

        // return httpClient.post(`/request/statement/rr/send/${requestId}`).then(promise => promise.data)
    }
    const addDocumentParticipant = async (documentId, participantId) => {
        const data = new FormData()
        data.append("DocumentId",documentId)
        data.append("ParticipantId",participantId)
        return httpClient.post("/request/document/participant", data).then(promise => promise.data)
    }
    return { request, regTypes, rightTypes, setRequest, getRequests, saveDocument, documentTypes, requestStatuses, deleteDocument, status, deleteParticipant, objectTypes, addFlSubject, addFlSubjectWithAgent, generateStatement, createRequest, addUlAgent, addSignature, addUlRepresentingFl, sendStatement, addDocumentParticipant }
}